import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

export default function SpawnRateDisplay({ spawnRatePercent, gramsPerBag, hasSelections }) {
  if (!hasSelections) return null

  const isLow = spawnRatePercent < 1.5

  return (
    <div className={cn(
      'flex items-center justify-between rounded-lg border px-4 py-3 text-sm',
      isLow
        ? 'border-amber-400/50 bg-amber-50'
        : 'border-border bg-surface-secondary/30'
    )}>
      <div className="flex items-center gap-3">
        {isLow && <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0" />}
        <span className={cn('font-medium', isLow && 'text-amber-600')}>
          {isLow ? 'Low Spawn Rate' : 'Spawn Rate'}
        </span>
      </div>
      <div className="flex items-center gap-4">
        <span className={cn('font-mono font-medium', isLow && 'text-amber-600')}>
          {spawnRatePercent.toFixed(1)}%
        </span>
        <span className="text-content-secondary">
          {gramsPerBag.toFixed(0)}g / bag
        </span>
      </div>
    </div>
  )
}
